import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { MenuItem, Menu, } from '@mui/material';
import { useTranslation } from 'react-i18next';
;
/**
 * MenuSG
 * @param {any} props
 * @returns {JSX.Element}
 */
export const MenuSG = function (props) {
    const { t } = useTranslation();
    const { shouldTranslated, id, anchorEl, open, onClose, onItemClick, transformOrigin, anchorOrigin, items, } = props;
    return (_jsx(Menu
    // Customized menu
    , Object.assign({ 
        // Customized menu
        anchorEl: anchorEl, id: id, open: open, onClose: onClose, onClick: onClose, transformOrigin: transformOrigin, anchorOrigin: anchorOrigin, sx: {
            '& div': {
                borderRadius: '12px',
            },
            '& ul': {
                borderColor: '#C0C9C1',
                backgroundColor: 'whiteDark.main',
                boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
                filter: 'drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3))',
            },
        } }, { children: items.map((item) => (_jsx(MenuItem
        // Customized menu item
        , Object.assign({ 
            // Customized menu item
            sx: {
                width: '100%',
                fontWeight: '400',
                fontSize: '1rem',
                lineHeight: '1.5rem',
                letterSpacing: '0.03125rem',
                color: '#191C1B',
                textAlign: 'left',
                alignItems: 'left',
                borderColor: '#707973',
            }, onClick: () => { onItemClick(item.value); } }, { children: shouldTranslated ? t(item.name) : (item.name) }), item.value))) })));
};
